(function () {
  var PLATFORM_URL = "https://www.unonight.com";

  function readPlatformUrl() {
    var node = document.querySelector("[data-unonight-platform-url]");
    return node ? node.getAttribute("data-unonight-platform-url") || PLATFORM_URL : PLATFORM_URL;
  }

  function readStoredReturnTo() {
    try {
      var fromUrl = new URLSearchParams(window.location.search).get("unonight_return");
      if (fromUrl) {
        sessionStorage.setItem("unonight_wishlist_return_to", fromUrl);
        return fromUrl;
      }
      var stored = sessionStorage.getItem("unonight_wishlist_return_to");
      if (stored) return stored;
    } catch (_error) {}
    return null;
  }

  function buildWishlistAddUrl(product) {
    if (!product || !product.variantId || !product.title) return null;

    var params = new URLSearchParams();
    params.set("variant_id", String(product.variantId).replace(/\D/g, ""));
    params.set("title", product.title);
    if (product.imageUrl) params.set("image_url", product.imageUrl);
    if (product.priceDisplay) params.set("price_display", product.priceDisplay);
    if (product.productId) params.set("product_id", String(product.productId));
    // shop_url = Shopify product page; return_to = platform manage page when known.
    if (product.shopUrl) params.set("shop_url", product.shopUrl);
    if (product.returnTo) params.set("return_to", product.returnTo);

    return readPlatformUrl().replace(/\/$/, "") + "/wishlist/add?" + params.toString();
  }

  function syncToUnonightProfile(product) {
    var url = buildWishlistAddUrl(product);
    if (!url) return;
    window.location.href = url;
  }

  function readProductFromForm() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return null;

    var variantInput = form.querySelector('input[name="id"]');
    var titleNode = document.querySelector("[data-product-title]");
    var imageNode = document.querySelector("[data-product-image-url]");
    var productIdNode = document.querySelector("[data-product-id]");
    var wishlistLink = document.querySelector("[data-unonight-wishlist]");
    var shopUrl = window.location.href;
    var imageUrl = imageNode ? imageNode.getAttribute("data-product-image-url") : null;
    if (!imageUrl && wishlistLink && wishlistLink.getAttribute("data-image-url")) {
      imageUrl = wishlistLink.getAttribute("data-image-url");
    }
    var storedReturn = readStoredReturnTo();
    var platform = readPlatformUrl().replace(/\/$/, "");

    return {
      variantId: variantInput ? variantInput.value : null,
      title: titleNode ? titleNode.getAttribute("data-product-title") || titleNode.textContent : document.title,
      imageUrl: imageUrl,
      productId: productIdNode ? productIdNode.getAttribute("data-product-id") : null,
      shopUrl: shopUrl,
      returnTo: storedReturn || platform + "/profile/wishlist"
    };
  }

  document.addEventListener("wishlist-hero-wishlist-sdk-ready", function () {
    var hero = window.WishlistHero || window.wishlistHero || window.WishListHero;
    if (!hero) return;

    if (typeof hero.on === "function") {
      hero.on("added", function (payload) {
        var platform = readPlatformUrl().replace(/\/$/, "");
        syncToUnonightProfile({
          variantId: payload && (payload.variantId || payload.variant_id),
          title: payload && (payload.title || payload.productTitle),
          imageUrl: payload && (payload.image || payload.imageUrl || payload.featured_image),
          productId: payload && (payload.productId || payload.product_id),
          shopUrl: window.location.href,
          returnTo: readStoredReturnTo() || platform + "/profile/wishlist"
        });
      });
    }
  });

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var button = target.closest("[data-unonight-wishlist-sync]");
    if (!button) return;
    event.preventDefault();
    syncToUnonightProfile(readProductFromForm());
  });
})();
